import { IAirline } from '@simplyfly/shared';
import { getOfferAirline } from './enquiry.helpers';
import { IEnquiryOffer } from '@simplyfly/shared';
export const getAirlineIdFromOffer = (enquiryOffer: IEnquiryOffer): string | null => {
  const airline: IAirline | null = getOfferAirline(enquiryOffer);

  if (airline) {
    return airline.id;
  } else if (enquiryOffer.aircraftCompiledId) {
    const splittedAircraftCompiledId: string[] = enquiryOffer.aircraftCompiledId.split('-');

    return splittedAircraftCompiledId[0];
  }

  return null;
};
